var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.45955 28.9543H26.5364C28.8647 28.9543 30.3164 27.2835 30.3164 25.1744C30.3164 24.5445 30.1521 23.9008 29.8096 23.3119L19.2506 4.91927C18.5385 3.67302 17.2785 3.00195 16.0049 3.00195C14.7175 3.00195 13.4575 3.67302 12.7454 4.91927L2.18641 23.3256C1.84404 23.9145 1.67969 24.5445 1.67969 25.1744C1.67969 27.2835 3.13137 28.9543 5.45955 28.9543Z",
    fill: "url(#paint0_linear_2581_64015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0434 18.6277C17.0297 19.3398 16.66 19.7233 16.0026 19.7233C15.3179 19.7233 14.9344 19.3261 14.9207 18.6277L14.7426 11.3966C14.7289 10.6981 15.2494 10.1914 15.9889 10.1914C16.7147 10.1914 17.2625 10.7118 17.2489 11.4103L17.0434 18.6277ZM17.4816 22.7497C17.4816 23.5441 16.7832 24.1741 16.0025 24.1741C15.2082 24.1741 14.5234 23.5304 14.5234 22.7497C14.5234 21.9554 15.1945 21.3255 16.0025 21.3255C16.7968 21.3255 17.4816 21.9417 17.4816 22.7497Z",
    fill: "url(#paint1_linear_2581_64015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2581_64015",
    x1: 1.67969,
    y1: 3.00195,
    x2: 1.67969,
    y2: 28.9543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2581_64015",
    x1: 14.5234,
    y1: 10.1914,
    x2: 14.5234,
    y2: 24.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.ef73a8d11eba6fc1476ec00e68c57f7d.svg";
export { ForwardRef as ReactComponent };